module.exports = __webpack_public_path__ + "static/detail.be62fda0.png";